module.exports = __webpack_public_path__ + "static/media/2024进度条-1_03.127b29d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_110/images/2024进度条-1_03.jpg
// module id = 1104
// module chunks = 0